import {
  ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH,
  ARTICLE_CANCEL_REVIEW_PATH,
  ARTICLE_CLOSE_REVIEW_PATH,
  ARTICLE_DISMISS_REVIEW_PATH,
  ARTICLE_ENDED_REVIEW_PATH,
  ARTICLE_NEW_REVIEW_PATH,
  ARTICLE_REVIEW_PATH,
  ARTICLE_SUBMIT_REVIEW_PATH,
  DOC_PATH,
  FOLDER_ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH,
  FOLDER_ARTICLE_CANCEL_REVIEW_PATH,
  FOLDER_ARTICLE_CLOSE_REVIEW_PATH,
  FOLDER_ARTICLE_DISMISS_REVIEW_PATH,
  FOLDER_ARTICLE_ENDED_REVIEW_PATH,
  FOLDER_ARTICLE_NEW_REVIEW_PATH,
  FOLDER_ARTICLE_REVIEW_PATH,
  FOLDER_ARTICLE_SUBMIT_REVIEW_PATH,
  FOLDER_DOC_PATH,
  HANDBOOK_PATH,
} from 'paths'
import { generatePath, useRouteMatch } from 'react-router-dom'
import { useCurrentArticleMeta } from './useCurrentArticleMeta'

interface BaseParams {
  slug?: string
}

interface ReviewRouteGenerators {
  show: (params: BaseParams & { reviewId: number }) => string
  new: (params: BaseParams) => string
  dismiss: (params: BaseParams & { reviewId: number }) => string
  submit: (params: BaseParams & { reviewId: number }) => string
  cancel: (params: BaseParams & { reviewId: number }) => string
  close: (params: BaseParams & { reviewId: number }) => string
  cancelAndMerge: (params: BaseParams & { reviewId: number }) => string
  ended: (params: BaseParams & { reviewId: number }) => string
}

export const useReviewsRoutes = (): ReviewRouteGenerators => {
  const inFolder = useRouteMatch<{ folderSlug: string; doc?: string }>(FOLDER_DOC_PATH)
  const inHandbook = useRouteMatch<{ folderSlug: string; doc?: string }>(HANDBOOK_PATH)
  const inDoc = useRouteMatch<{ slug: string }>(DOC_PATH)
  const docSlug = useCurrentArticleMeta()?.slug
  // This is to be 100% safe and have fallbacks for all the cases we can't
  // handle via url. For example, when opening the cover document of a handbook,
  // the doc key is not in the url, so we need to fetch it from redux.
  const slug = docSlug || inFolder?.params.doc || inHandbook?.params.doc || inDoc?.params.slug || ''

  if (inFolder) {
    const generator = (path: string) => (params?: any) =>
      generatePath(path, { ...params, ...inFolder.params, doc: params?.doc || slug })

    return {
      show: generator(FOLDER_ARTICLE_REVIEW_PATH),
      new: generator(FOLDER_ARTICLE_NEW_REVIEW_PATH),
      dismiss: generator(FOLDER_ARTICLE_DISMISS_REVIEW_PATH),
      submit: generator(FOLDER_ARTICLE_SUBMIT_REVIEW_PATH),
      cancel: generator(FOLDER_ARTICLE_CANCEL_REVIEW_PATH),
      close: generator(FOLDER_ARTICLE_CLOSE_REVIEW_PATH),
      cancelAndMerge: generator(FOLDER_ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH),
      ended: generator(FOLDER_ARTICLE_ENDED_REVIEW_PATH),
    }
  }

  const generator = (path: string) => (params?: any) =>
    generatePath(path, { ...params, ...inDoc?.params, slug: params?.slug || slug })

  return {
    show: generator(ARTICLE_REVIEW_PATH),
    new: generator(ARTICLE_NEW_REVIEW_PATH),
    dismiss: generator(ARTICLE_DISMISS_REVIEW_PATH),
    submit: generator(ARTICLE_SUBMIT_REVIEW_PATH),
    cancel: generator(ARTICLE_CANCEL_REVIEW_PATH),
    close: generator(ARTICLE_CLOSE_REVIEW_PATH),
    cancelAndMerge: generator(ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH),
    ended: generator(ARTICLE_ENDED_REVIEW_PATH),
  }
}
